import {ROOT_URL} from '../../config';
import request from '../../components/api/api';
import {toastr} from 'react-redux-toastr';
import {push} from 'react-router-redux';
import {
    fetchedFaqsTypes,
    fetchedFaq,
    createdFaq,
    updatedFaq,
    deletedFaq,
    fetchedFaqsTranslations,
    fetchedFaqTranslation,
    createdFaqTranslation,
    updatedFaqTranslation,
    deletedFaqTranslation
} from './actions';

export function fetchFaq(id) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/faqs/${id}`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedFaq(response.data)))
    }
}

export function fetchFaqsTypes() {
    return dispatch => {

        let options = {
            url: `${ROOT_URL}/faq-types`,
            method: 'GET'
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedFaqsTypes(response.data)))
    }
}

export function createFaq(faq) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/faqs`,
            method: 'POST',
            data: {
                faq_type_id: faq.faq_type_id,
                title: faq.title,
                body: faq.body
            }
        };

        return request(options, dispatch)
            .then(response => dispatch(createdFaq(response)))
            .then(() => toastr.success('Success!', 'The FAQ has been created.'))
            .then(() => dispatch(push(`/faqs`)))
    }
}

export function updateFaq(faq) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/faqs/${faq.id}`,
            method: 'PUT',
            data: {
                id: faq.id,
                faq_type_id: faq.faq_type_id,
                title: faq.title,
                body: faq.body
            }
        };

        return request(options, dispatch)
            .then(response => dispatch(updatedFaq(faq)))
            .then(() => toastr.success('Success!', 'The FAQ has been updated.'))
    };
}

export function deleteFaq(id) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/faqs/${id}`,
            method: 'DELETE'
        };
        return request(options, dispatch)
            .then(response => dispatch(deletedFaq(id)))
            .then(() => toastr.success('Success!', 'FAQ with ID ' + id + ' has been deleted.'))
    }
}

export function fetchFaqsTranslations(id) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/faqs/${id}/translations`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedFaqsTranslations(response.data)))
    }
}

export function fetchFaqTranslation(faqId, translationId) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/faqs/${faqId}/translations/${translationId}`,
            method: 'GET'
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedFaqTranslation(response.data)))
    };
}

export function createFaqTranslation(translation, faqId) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/faqs/${faqId}/translations`,
            method: 'POST',
            data: {
                title: translation.title,
                body: translation.body,
                site_id: translation.site_id
            }
        };

        return request(options, dispatch)
            .then(response => dispatch(createdFaqTranslation(translation)))
            .then(() => toastr.success('Success!', 'The translation has been successfully created!'))
            .then(() => dispatch(push(`/faqs/${faqId}/translations`)))
    }
}

export function updateFaqTranslation(translation, faqId, translationId) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/faqs/${faqId}/translations/${translationId}`,
            method: 'PUT',
            data: {
                title: translation.title,
                body: translation.body,
                site_id: translation.site_id
            }
        };

        return request(options, dispatch)
            .then(response => dispatch(updatedFaqTranslation(translation)))
            .then(() => toastr.success('Success!', 'The translation has been successfully updated!'))
    }
}

export function deleteFaqTranslation(faqId, translationId) {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/faqs/${faqId}/translations/${translationId}`,
            method: 'DELETE'
        };
        return request(options, dispatch)
            .then(response => dispatch(deletedFaqTranslation(translationId)))
            .then(() => toastr.success('Success!', 'Translation with ID ' + translationId + ' has been deleted.'))
    }
}


// WEBPACK FOOTER //
// ./src/containers/faqs/thunks.js